import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleOpen = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-20 bg-brand-black border-t border-white/5" data-id="element-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12" data-id="element-102">
          <div data-id="element-103">
            <p className="text-brand-red font-oswald text-sm tracking-[0.3em] uppercase mb-3" data-id="element-104">
              Got Questions?
            </p>
            <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase" data-id="element-105">
              {t.faq.title}
            </h2>
          </div>
          <p className="text-gray-500 text-sm max-w-xs" data-id="element-106">
            Can't find your answer? Call us at{' '}
            <a href="tel:8134768935" className="text-brand-yellow hover:text-white font-bold transition-colors" data-id="element-107">
              (813) 476-8935
            </a>
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3" data-id="element-108">
          {t.faq.questions.map((faq: any, index: number) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className={`rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'bg-white/[0.06] border border-brand-red/20' : 'bg-white/[0.02] border border-white/5 hover:border-white/10'}`} data-id="element-109">
                <button onClick={() => toggleOpen(index)} className="w-full px-6 py-5 flex items-center gap-4 text-left focus:outline-none transition-colors" data-id="element-110">
                  {/* Number */}
                  <span className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center font-oswald font-bold text-sm transition-colors ${isOpen ? 'bg-brand-red text-white' : 'bg-white/5 text-gray-500'}`} data-id="element-111">
                    {String(index + 1).padStart(2, '0')}
                  </span>

                  <span className={`flex-1 font-medium text-base transition-colors ${isOpen ? 'text-white' : 'text-gray-300'}`} data-id="element-112">
                    {faq.q}
                  </span>

                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center transition-colors ${isOpen ? 'bg-brand-red/10 text-brand-red' : 'bg-white/5 text-gray-500'}`} data-id="element-113">
                    <ChevronDown className="w-4 h-4" data-id="element-114" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-115">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-116">
                      <div className="px-6 pb-5 pl-[72px] text-gray-400 text-sm leading-relaxed" data-id="element-117">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}